"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: l, size: c = 24 } = _param, o = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = s(), h = l !== null && l !== void 0 ? l : i ? t.colors.inverse : t.colors.neutralHigh, { skinName: r } = n();
    return r.match(/^o2-new/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: h,
                d: "M7.536 13.788a.72.72 0 0 1-.716-.716c0-.396.32-.716.72-.724h.356c-.036-.104-.036-.252-.036-.356 0-.052.009-.113.018-.175.009-.063.018-.127.018-.181H7.54a.72.72 0 0 1-.716-.716c0-.392.32-.716.716-.716h.716c.712-1.676 2.356-2.856 4.284-2.856.824 0 1.608.248 2.324.644a.69.69 0 0 1 .252.964.69.69 0 0 1-.964.252 3.2 3.2 0 0 0-1.608-.428 3.24 3.24 0 0 0-2.68 1.428h2.68c.392 0 .716.32.716.716 0 .392-.32.716-.716.716h-3.18c-.036.104-.036.252-.036.356 0 .051.009.113.018.175.009.063.018.127.018.181h3.176c.392 0 .716.32.716.716 0 .392-.32.716-.716.716H9.86a3.24 3.24 0 0 0 2.68 1.428q.858-.001 1.608-.428c.32-.212.748-.104.964.252.212.32.104.748-.252.964-.716.428-1.5.644-2.324.644-1.928 0-3.568-1.176-4.284-2.856z"
            }),
            /* @__PURE__ */ e("path", {
                fill: h,
                d: "M12 2C6.5 2 2 6.5 2 12s4.464 10 10 10c5.5 0 10-4.464 10-10 0-5.5-4.5-10-10-10m0 18.568A8.55 8.55 0 0 1 3.428 12 8.55 8.55 0 0 1 12 3.428c4.752 0 8.572 3.856 8.572 8.572A8.55 8.55 0 0 1 12 20.568"
            })
        ]
    })) : r.match(/^o2/i) ? /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: h,
                d: "M7.536 13.788a.72.72 0 0 1-.716-.716c0-.396.32-.716.72-.724h.356c-.036-.104-.036-.252-.036-.356 0-.052.009-.113.018-.175.009-.063.018-.127.018-.181H7.54a.72.72 0 0 1-.716-.716c0-.392.32-.716.716-.716h.716c.712-1.676 2.356-2.856 4.284-2.856.824 0 1.608.248 2.324.644a.69.69 0 0 1 .252.964.69.69 0 0 1-.964.252 3.2 3.2 0 0 0-1.608-.428 3.24 3.24 0 0 0-2.68 1.428h2.68c.392 0 .716.32.716.716 0 .392-.32.716-.716.716h-3.18c-.036.104-.036.252-.036.356 0 .051.009.113.018.175.009.063.018.127.018.181h3.176c.392 0 .716.32.716.716 0 .392-.32.716-.716.716H9.86a3.24 3.24 0 0 0 2.68 1.428q.858-.001 1.608-.428c.32-.212.748-.104.964.252.212.32.104.748-.252.964-.716.428-1.5.644-2.324.644-1.928 0-3.568-1.176-4.284-2.856z"
            }),
            /* @__PURE__ */ e("path", {
                fill: h,
                d: "M12 2C6.5 2 2 6.5 2 12s4.464 10 10 10c5.5 0 10-4.464 10-10 0-5.5-4.5-10-10-10m0 18.568A8.55 8.55 0 0 1 3.428 12 8.55 8.55 0 0 1 12 3.428c4.752 0 8.572 3.856 8.572 8.572A8.55 8.55 0 0 1 12 20.568"
            })
        ]
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ e("path", {
            fill: h,
            d: "M11.995 2.155c6.44 0 9.846 3.403 9.846 9.846 0 6.437-3.403 9.84-9.846 9.84-6.437 0-9.84-3.403-9.84-9.84 0-6.443 3.403-9.846 9.84-9.846m0 18.479c5.732 0 8.639-2.905 8.639-8.633 0-5.734-2.905-8.639-8.639-8.639-5.728 0-8.633 2.905-8.633 8.639 0 5.728 2.905 8.633 8.633 8.633m4.684-4.339a.6.6 0 0 0-.801-.283c-.7.33-1.575.499-2.603.496-2.459 0-3.95-.916-4.526-2.773h3.563a.604.604 0 1 0 0-1.21H8.528l-.007-.066c-.023-.241-.047-.485-.047-.755q.002-.114.012-.217.007-.071.01-.144h3.81a.601.601 0 1 0 0-1.205H8.642C9.107 7.976 10.626 6.9 13.276 6.9c1.014 0 1.882.163 2.576.485a.603.603 0 1 0 .508-1.096c-.855-.397-1.894-.596-3.085-.596-3.316 0-5.352 1.566-5.873 4.445H6.374a.602.602 0 0 0 0 1.205h.901q-.001.045-.004.09-.009.134-.01.271.003.41.04.82h-.927a.604.604 0 1 0 0 1.21h1.12c.65 2.583 2.644 3.981 5.779 3.981 1.207 0 2.255-.204 3.117-.61h.003a.603.603 0 0 0 .289-.804z"
        })
    }));
}, v = m;
export { v as default };
